import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { formatCurrencyValue } from '@vend/utilities'
import classNames from 'classnames'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleFinals } from '../../../state/slices/currentSale/currentSaleSlice'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'

export const SaleSubtotal: FunctionComponent = () => {
  const finals = useAppSelector(selectSaleFinals)
  const retailer = useRetailerSettingsManager().get()
  const registerManager = useRegisterManager()
  const currentOutlet = registerManager.getActiveOutlet()
  const isTaxInclusive = registerManager.isTaxInclusive()
  return (
    <li
      className={classNames('sale-summary-line sale-summary-line--sub-total', {
        'vd-pt2': isTaxInclusive, // only apply padding if tax inclusive because it won't be the first item
      })}
    >
      <div className="sale-summary-line-item sale-summary-line-item--label">
        <T _str="Subtotal" _context="Subtotal of the sale" />
      </div>
      <div className="sale-summary-line-item sale-summary-line-item--value">
        {formatCurrencyValue(
          finals.subtotal,
          retailer.culture,
          currentOutlet.currency,
          currentOutlet.currency_symbol
        )}
      </div>
    </li>
  )
}
